import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { createInfraHubQueryClient } from './query/query-client.js';
import { createInfraHubLiveRouter } from './router.js';
import './styles.css';

const root = document.getElementById('root');

if (root === null) {
  throw new Error('Missing #root mount element.');
}

const queryClient = createInfraHubQueryClient();
const router = createInfraHubLiveRouter();

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
